export enum AgreementListFilterActionsEnum {
  AGREEMENT_LIST_FILTER_SET_SWITCHER = 'AGREEMENT_LIST_FILTER_SET_SWITCHER',
  AGREEMENT_LIST_FILTER_SET_CURRENT = 'AGREEMENT_LIST_FILTER_SET_CURRENT',
  AGREEMENT_LIST_FILTER_SET_PLAN_NUM = 'AGREEMENT_LIST_FILTER_SET_PLAN_NUM',
  AGREEMENT_LIST_FILTER_GET_META = 'AGREEMENT_LIST_FILTER_GET_META',
  AGREEMENT_LIST_FILTER_SET_META = 'AGREEMENT_LIST_FILTER_SET_META',
  AGREEMENT_LIST_FILTER_GET_DATA = 'AGREEMENT_LIST_FILTER_GET_DATA',
  AGREEMENT_LIST_FILTER_SET_DATA = 'AGREEMENT_LIST_FILTER_SET_DATA',
  AGREEMENT_LIST_FILTER_CREATE = 'AGREEMENT_LIST_FILTER_CREATE',
  AGREEMENT_LIST_FILTER_UPDATE = 'AGREEMENT_LIST_FILTER_UPDATE',
  AGREEMENT_LIST_FILTER_REMOVE = 'AGREEMENT_LIST_FILTER_REMOVE',
  AGREEMENT_LIST_FILTER_INIT = 'AGREEMENT_LIST_FILTER_INIT',
}
